/**
 * DEV-ONLY harness for the template editor (same pattern as DevFixesPage): drives the real two-pane
 * TemplateEditor against a static sample bundle (public/dev-template-sample.json, the offer-letter
 * definition with a realistic pre-fill) with no auth and no backend. Drafting returns canned prose
 * after a short delay so the auto-draft flow is exercised; Create just reports the answer counts.
 * Handy for design review at /dev/template without signing in.
 */

import { useEffect, useState } from 'react';
import { TemplateEditor } from '../components/TemplateEditor';
import type { TemplateAnswers, TemplateBundle } from '../../lib/entities/templates';
import '../../styles/app.css';

const CANNED_DRAFT =
  'Please come to the main reception at Unit 4 for 8.45am on your first day and ask for Tom Reid. '
  + 'He will show you round, introduce you to the team and go through your induction over the first two days. '
  + 'Please bring the right to work documents we have discussed, your bank account details and your National '
  + 'Insurance number so that payroll can set you up in time for the September pay run.';

export default function DevTemplatePage() {
  const [bundle, setBundle] = useState<TemplateBundle | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/dev-template-sample.json')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((b: TemplateBundle) => setBundle(b))
      .catch((err: unknown) => setError(err instanceof Error ? err.message : 'load failed'));
  }, []);

  if (error) return <p style={{ padding: 24 }}>Could not load the sample bundle: {error}</p>;
  if (!bundle) return <p style={{ padding: 24 }}>Loading…</p>;

  return (
    <div style={{ padding: '18px 24px', background: 'var(--bg, #faf8f5)', minHeight: '100vh' }}>
      <TemplateEditor
        bundle={bundle}
        backHref="/dev/template"
        onDraft={(draftId) =>
          new Promise((resolve) => setTimeout(() => resolve({ text: `${CANNED_DRAFT} (${draftId})` }), 700))
        }
        onCreate={async (answers: TemplateAnswers) => {
          // eslint-disable-next-line no-alert
          window.alert(
            `Would create the document with ${Object.keys(answers.values).length} answers `
            + `and ${Object.keys(answers.repeats).length} register(s).`,
          );
        }}
      />
    </div>
  );
}
